import React, { useEffect, useRef, useState } from 'react';
import { Modal, View, Text, TouchableOpacity, StyleSheet, Dimensions, TextInput } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const { width } = Dimensions.get('window');

export default function CustomAlert({
  visible,
  title,
  message,
  type = 'info',
  onConfirm,
  onCancel,
  confirmText = "Tamam",
  cancelText = "Vazgeç",
  showCancel = false,
  onBarkodScanned, // opsiyonel: Bluetooth HID barkod okuyucu desteği
}) {

  const scannerInputRef = useRef(null);
  const [scannerBuffer, setScannerBuffer] = useState('');

  useEffect(() => {
    if (visible && onBarkodScanned) {
      const timers = [80, 250, 500].map((d) =>
        setTimeout(() => scannerInputRef.current?.focus(), d)
      );
      return () => timers.forEach(clearTimeout);
    }
  }, [visible, onBarkodScanned]);

  const submitScanner = (raw) => {
    const code = (raw || '').replace(/[\r\n\t]+/g, '').trim();
    setScannerBuffer('');
    if (code.length >= 3 && typeof onBarkodScanned === 'function') {
      onBarkodScanned(code);
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success': return { name: 'checkmark-circle', color: '#10b981' };
      case 'error': return { name: 'alert-circle', color: '#ef4444' };
      case 'warning': return { name: 'warning', color: '#f59e0b' };
      default: return { name: 'information-circle', color: '#2563eb' };
    }
  };

  const icon = getIcon();

  // --- YENİ: Vurgulu Metin İşleyici ---
const renderMessage = () => {
    if (!message) return null;
    
    // YENİ: Eğer mesaj zaten bir React bileşeni (JSX) ise direkt döndür
    if (typeof message !== 'string') {
      return <View style={{ marginBottom: 20 }}>{message}</View>;
    }
    
    // Eski mantık: Sadece metin ise split işlemini yap
    const parts = message.split(/(\*.*?\*)/g);
    
    return (
      <Text style={styles.message}>
        {parts.map((part, index) => {
          if (part.startsWith('*') && part.endsWith('*')) {
            return (
              <Text key={index} style={styles.boldHighlight}>
                {part.replace(/\*/g, '')}
              </Text>
            );
          }
          return part;
        })}
      </Text>
    );
  };

  return (
    <Modal visible={visible} transparent animationType="fade">
      <View style={styles.overlay}>
        {onBarkodScanned && (
          <TextInput
            ref={scannerInputRef}
            value={scannerBuffer}
            onChangeText={(t) => {
              if (/[\r\n]/.test(t)) submitScanner(t);
              else setScannerBuffer(t);
            }}
            onSubmitEditing={(e) => submitScanner(e?.nativeEvent?.text ?? scannerBuffer)}
            onBlur={() => {
              if (visible) setTimeout(() => scannerInputRef.current?.focus(), 30);
            }}
            showSoftInputOnFocus={false}
            caretHidden
            submitBehavior="submit"
            autoCorrect={false}
            autoCapitalize="none"
            contextMenuHidden
            style={styles.hiddenScannerInput}
          />
        )}
        <View style={styles.alertBox}>
          <View style={[styles.iconContainer, { backgroundColor: icon.color + '15' }]}>
            <Ionicons name={icon.name} size={40} color={icon.color} />
          </View>
          
          <Text style={styles.title}>{title}</Text>
          
          {/* Standart Text yerine yeni fonksiyonu çağırıyoruz */}
          {renderMessage()}

          <View style={styles.buttonRow}>
            {showCancel && (
              <TouchableOpacity style={styles.cancelBtn} onPress={onCancel}>
                <Text style={styles.cancelBtnText}>{cancelText}</Text>
              </TouchableOpacity>
            )}
            <TouchableOpacity 
              style={[styles.confirmBtn, { backgroundColor: icon.color }]} 
              onPress={onConfirm}
            >
              <Text style={styles.confirmBtnText}>{confirmText}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'center', alignItems: 'center' },
  alertBox: { width: width * 0.85, backgroundColor: 'white', borderRadius: 24, padding: 25, alignItems: 'center', elevation: 20 },
  iconContainer: { width: 80, height: 80, borderRadius: 40, justifyContent: 'center', alignItems: 'center', marginBottom: 20 },
  title: { fontSize: 20, fontWeight: '800', color: '#1e293b', marginBottom: 10, textAlign: 'center' },
  message: { fontSize: 14, color: '#64748b', textAlign: 'center', lineHeight: 22, marginBottom: 25 },
  
  // Vurgulu metin stili
  boldHighlight: { 
    fontWeight: '900', 
    color: '#0f172a', // Daha koyu, neredeyse siyah bir renk
  },

  buttonRow: { flexDirection: 'row', width: '100%', gap: 10 },
  confirmBtn: { flex: 1, height: 50, borderRadius: 15, justifyContent: 'center', alignItems: 'center' },
  confirmBtnText: { color: 'white', fontWeight: '700', fontSize: 15 },
  cancelBtn: { flex: 1, height: 50, borderRadius: 15, justifyContent: 'center', alignItems: 'center', backgroundColor: '#f1f5f9' },
  cancelBtnText: { color: '#64748b', fontWeight: '700', fontSize: 15 },

  hiddenScannerInput: { position: 'absolute', top: -1000, left: -1000, width: 1, height: 1, opacity: 0 },
});